import { Link } from "gatsby"
import React, { useRef, useEffect, useState } from "react"
import Logo from "../../images/pharms-logo.svg"
// import IconTel from "../../images/icon-tel.svg"
import Button from "../Button"
import {
  header,
  wrap,
  title,
  menu,
  nav,
  navItem,
  pulldownItem,
  pulldownButton,
  pulldown,
  megaMenuListItem,
  megaMenu,
  megaMenuBg,
  megaMenuList,
  downloadTitle,
  downloadButton,
  downloadIcon,
  documents,
  hamburgerMenu,
  inquirySP,
  inquirySPButton,
  inquirySPList,
  inquiryPCButton,
  inquiryPC,
  bulb,
  open as openStyle
} from "./header.module.scss"

import Resource from "../../images/img-resource.png"
import Only3min from "../../images/img-3min-top.png"

export default React.memo(() => {
  const [isOpen_1, setIsOpen_1] = useState(false)
  const [isOpen_2, setIsOpen_2] = useState(false)
  const [isOpen_3, setIsOpen_3] = useState(false)
  const [isOpen_DL, setIsOpen_DL] = useState(false)
  const [spOpen, setSpOpen] = useState(false);
  const spRef: any = useRef();
  const menuRef_1: any = useRef()
  const menuRef_2: any = useRef()
  const menuRef_3: any = useRef()
  const menuRef_DL: any = useRef()

  useEffect(() => {
    isOpen_1 && menuRef_1.current.focus()
  }, [isOpen_1])
  useEffect(() => {
    isOpen_2 && menuRef_2.current.focus()
  }, [isOpen_2])
  useEffect(() => {
    isOpen_3 && menuRef_3.current.focus()
  }, [isOpen_3])
  useEffect(() => {
    isOpen_DL && menuRef_DL.current.focus()
  }, [isOpen_DL])
  useEffect(() => {
    spOpen && spRef.current.focus();
  }, [spOpen]);

  return (
    <div className={`${header} ${spOpen && `${openStyle}`} ${isOpen_DL && `${openStyle}`}`}>
      <div className={wrap}>
        <p className={title}>
          <Link
            to="/"
            style={{
              color: `white`,
              textDecoration: `none`,
            }}
          >
            <img src={Logo} alt="かかりつけ薬局支援システム Pharms（ファームス）" width="auto" height="42px" />
            {/* <span>かかりつけ薬局支援システム<strong>Pharms（ファームス）</strong></span> */}
          </Link>
        </p>
        <div className={`${menu} ${spOpen && `${openStyle}`}`} ref={spRef} >
          <ul className={nav}>
            <li className={navItem}>
              <Button className={pulldownButton} color="nav" onClick={() => setIsOpen_1(isOpen_1 ? false : true)}>Pharmsとは</Button>
              {isOpen_1 &&
                <ul className={pulldown} ref={menuRef_1} tabIndex={1} onBlur={() => setTimeout(() => setIsOpen_1(false), 200)}>
                  <li className={pulldownItem}><Link to="/product/">選ばれる理由</Link></li>
                  <li className={pulldownItem}><Link to="/product/function">機能一覧</Link></li>
                  <li className={pulldownItem}><Link to="/product/flow/">導入の流れ</Link></li>
                  <li className={pulldownItem}><Link to="/security/" target="_blank">セキュリティ</Link></li>
                </ul>
              }
            </li>
            <li className={navItem}>
              <Button className={pulldownButton} color="nav" onClick={() => setIsOpen_2(isOpen_2 ? false : true)}>機能</Button>
              {isOpen_2 &&
                <ul className={pulldown} ref={menuRef_2} tabIndex={1} onBlur={() => setTimeout(() => setIsOpen_2(false), 200)}>
                  <li className={pulldownItem}><Link to="/product/delivery/">当日配達機能</Link></li>
                  <li className={pulldownItem}><Link to="/product/online/">オンライン服薬指導</Link></li>
                  <li className={pulldownItem}><Link to="/product/followup/">服薬フォローアップ</Link></li>
                  <li className={pulldownItem}><Link to="/product/medicalnote/">お薬手帳</Link></li>
                  <li className={pulldownItem}><Link to="/product/checkin/">店舗チェックイン</Link></li>
                </ul>
              }
            </li>
            <li className={navItem}>
              <Button className={pulldownButton} color="nav" onClick={() => setIsOpen_3(isOpen_3 ? false : true)}>サポート・料金</Button>
              {isOpen_3 &&
                <ul className={pulldown} ref={menuRef_3} tabIndex={1} onBlur={() => setTimeout(() => setIsOpen_3(false), 200)}>
                  <li className={pulldownItem}><Link to="/support/">充実のサポート</Link></li>
                  <li className={pulldownItem}><Link to="/price/">料金</Link></li>
                  <li className={pulldownItem}><Link to="/faq/">よくある質問</Link></li>
                </ul>
              }
              </li>
              <li className={navItem}>
              <Button
                color="nav"
                href="/case/"
              >
                導入事例
              </Button>
            </li>
            <li className={navItem}>
              <Button
                color="nav"
                href="/event/"
              >
                セミナー
              </Button>
            </li>
            <li className={navItem}>
              <Button
                color="nav"
                href="/column/"
              >
                お役立ち
              </Button>
            </li>
          </ul>
          <div className={inquiryPC}>
            <Button
              className={inquiryPCButton}
              color="border"
              href="/form/inquiry"
            >
              お問い合わせ
            </Button>
            <Button
              className={inquiryPCButton} onClick={() => setIsOpen_DL(isOpen_DL ? false : true)}
              color="primary"
            >
              資料ダウンロード
            </Button>
          </div>
          <div className={inquirySP}>
            <ul className={inquirySPList}>
              <li>
                <div className={downloadTitle}>
                    <div className={`${downloadIcon} ${documents} `}/>
                    目的に合わせて選べる
                </div>
                <Button
                  className={downloadButton}
                  color="border"
                  href="/resource"
                >
                  資料一覧
                </Button>
              </li>
              <li>
                <div className={downloadTitle}>
                  <div className={`${downloadIcon} ${bulb} `}/>
                  サービス内容や成功事例をご紹介
                </div>
                <Button
                  className={downloadButton}
                  color="primary"
                  href="/form/3min"
                >
                  3分でわかるPharms
                </Button>
              </li>
            </ul>
            <Button
              className={inquirySPButton}
              color="border"
              href="/form/inquiry"
            >
              お問い合わせ
            </Button>
          </div>
        </div>
        <div className={megaMenu} ref={menuRef_DL} tabIndex={2} onBlur={() => setTimeout(() => setIsOpen_DL(false), 200)}>
          <ul className={megaMenuList}>
            <li className={megaMenuListItem}>
              <img src={Resource} alt="資料一覧" width="100%" height="auto" />
              <p>目的に合わせて選べる</p>
              <Button
                className={downloadButton}
                color="border"
                href="/resource"
              >
                資料一覧
              </Button>
            </li>
            <li className={megaMenuListItem}>
              <img src={Only3min} alt="Pharmsご紹介資料" width="100%" height="auto" />
              <p>サービス内容や成功事例をご紹介</p>
              <Button
                className={downloadButton}
                color="primary"
                href="/form/3min"
              >
                3分でわかるPharms
              </Button>
            </li>
          </ul>
        </div>
        <div className={hamburgerMenu} onClick={() => setSpOpen(spOpen ? false : true)}>
          <span/>
          <span/>
          <span/>
        </div>
      </div>
      <div className={megaMenuBg}/>
    </div>
  )
})
